import PropTypes from "prop-types";
import React, { Component } from "react";

import iconSprite from "../../../../../images/img/chat/icons.svg";
import CustomerHappinessType from "../../../constants/ChatCustomerHappinessTypes";
import SvgIcon from "../../common/SvgIcon";

class RatingSystemThreeFaces extends Component {
    constructor() {
        super();

        this.onRateNegative = this.onRateNegative.bind(this);
        this.onRateNeutral = this.onRateNeutral.bind(this);
        this.onRatePositive = this.onRatePositive.bind(this);
    }

    onRateNegative() {
        this.props.onRate(CustomerHappinessType.NEGATIVE_3);
    }

    onRateNeutral() {
        this.props.onRate(CustomerHappinessType.NEUTRAL_3);
    }

    onRatePositive() {
        this.props.onRate(CustomerHappinessType.POSITIVE_3);
    }

    render() {
        return (
            <div className="rating-system-container">
                <button
                    name="rate positive"
                    aria-label="rate positive"
                    className="rate-btn rate-btn-first rate-positive"
                    onClick={this.onRatePositive}
                >
                    <SvgIcon src={iconSprite} id="smiley-green" />
                </button>
                <button
                    name="rate neutral"
                    aria-label="rate neutral"
                    className="rate-btn rate-neutral"
                    onClick={this.onRateNeutral}
                >
                    <SvgIcon src={iconSprite} id="smiley-yellow" />
                </button>
                <button
                    name="rate negative"
                    aria-label="rate negative"
                    className="rate-btn rate-btn-last rate-negative"
                    onClick={this.onRateNegative}
                >
                    <SvgIcon src={iconSprite} id="smiley-red" />
                </button>
            </div>
        );
    }
}

RatingSystemThreeFaces.propTypes = {
    onRate: PropTypes.func.isRequired,
};

export default RatingSystemThreeFaces;
